// Pricing Constants
export const KUNDALI_OFFER_PRICE = 299;
export const KUNDALI_ORIGINAL_PRICE = 499;

// Consultation Services Pricing
export const CHAT_CONSULTATION_PRICE = 999;
export const CALL_CONSULTATION_PRICE = 3100;
export const PREMIUM_SESSION_PRICE = 5100;

// Scroll Thresholds
export const SCROLL_THRESHOLD_STICKY_CTA = 300;

// Animation Durations
export const FADE_IN_DURATION = 0.4;
export const HOVER_TRANSITION_DURATION = 0.3;
